import { directive as vClickOutside } from 'vue-clickaway'
import { Loading } from 'element-ui';
import VueScrollTo from 'vue-scrollto'
import {rutDirective} from "@/directives/rut.directive";

/**
 * You can register global directives here and use them as a plugin in your main Vue instance
 */

const GlobalDirectives = {
  install (Vue) {
    Vue.directive('click-outside', vClickOutside)
    Vue.use(Loading.directive)
    Vue.use(VueScrollTo)
    Vue.directive('rut', rutDirective)
  }
}

export default GlobalDirectives
